// NOTE: x-api-key kabhi frontend me mat daalo. Ye calls aapke apne backend ko jaati hain,
// backend Wingpay ko x-api-key ke saath hit karta hai.
//
// `axiosInstance` ko apne project ke us instance se replace karo jo billPayApi.js me use ho raha hai.
import axiosInstance from "./axiosInstance";

// Wingpay response: { statusCode: "200", message, data }
// Aapka backend ise as-is ya { success, message, data } ke form me bhej sakta hai. Dono handle hain.
const normalize = (body) => {
  const ok = body?.success === true || String(body?.statusCode) === "200";
  return {
    success: ok,
    message: body?.message,
    // wrapped (data.data / data.bill) ya direct (data) dono chalega
    data: body?.data?.data ?? body?.data?.bill ?? body?.data ?? null,
  };
};

const errorResult = (err) => ({
  success: false,
  message: err?.response?.data?.message || err?.message || "Server Error",
  data: null,
});

/**
 * POST /api/UtilityTransaction/bbps/v1/CreditCardBillFetch
 * payload: { Last4DigitCardNumber, MobileNo, BillerId, Param1, Param2 }
 */
export const fetch_cc_bill = async (payload) => {
  try {
    const res = await axiosInstance.post("/api/bill/credit-card/fetch", payload);
    return normalize(res?.data);
  } catch (err) {
    return errorResult(err);
  }
};

/**
 * POST /api/UtilityTransaction/bbps/v1/CreditCardBillPayment
 * payload: { Last4DigitCardNumber, MobileNo, reference_id, amount, BillerId, OrderId, Param1, Param2,
 *            latitude, longitude }
 */
export const pay_cc_bill = async (payload) => {
  try {
    const res = await axiosInstance.post("/api/bill/credit-card/pay", payload);
    return normalize(res?.data);
  } catch (err) {
    return errorResult(err);
  }
};

/**
 * GET /bbps/credit-card/history
 * params: { page, limit, startDate, endDate, search, status, sortBy, sortDir }
 * returns: { success, message, data: { utilityPayments, pagination, totalAmount } }
 */
export const fetch_cc_history = async (params) => {
  try {
    const res = await axiosInstance.get("/api/bill/credit-card/history", { params });
    return normalize(res?.data);
  } catch (err) {
    return errorResult(err);
  }
};

/**
 * GET /api/bill/credit-card/billers
 * Fetches only active credit card billers
 */
export const fetch_active_cc_billers = async () => {
  try {
    const res = await axiosInstance.get("/api/bill/credit-card/billers");
    return normalize(res?.data);
  } catch (err) {
    return errorResult(err);
  }
};


// api
export const fetch_cc_payment_by_id = async (id) => {
  try {
    const res = await axiosInstance.get(`/api/bill/credit-card/history/${id}`);
    return normalize(res?.data);
  } catch (err) {
    return errorResult(err);
  }
};